
import api from 'api';
import { AppAction, AppButton, AppFormLayout, AppGridLayout, AppRow, AppSearchItem, AppTable, AppTableSearch } from 'qcc';
import React from 'react';

interface Props {
  projectId: number,
  callback: (selected?: any[]) => void
}
export default class EnterpriseRcbIntroduce extends React.Component<Props>{
  state = { intProjectId: 0 }
  onBeforeApi = async (data?: any) => {
    if (data.projectId !== undefined) {
      return data;
    }
  }
  // 引入
  introduce = async () => {
    let selected = this.refTable.current.getSelected();
    if (selected.length === 0) {
      AppAction.closeDialog()
    } else {
      this.props.callback && this.props.callback(selected);
    }
  }
  onSearch = async (filterList?: any[], data?: any) => {
    let intProjectId = data.projectId || 0;
    this.setState({ intProjectId }, this.fetchTable)
  }
  fetchTable = async () => {
    let { intProjectId } = this.state;
    let projectId = this.props.projectId
    let list = await api.posenterprisercb.getintroduceList({ projectId, intProjectId });
    this.refTable.current && this.refTable.current.setDataSource(list);
  }

  refTable = React.createRef<AppTable>();
  refGrid = React.createRef<AppGridLayout>();
  refTableSearch = React.createRef<AppTableSearch>();
  render() {
    return (
      <AppFormLayout>
        <AppFormLayout.Form>
          <AppGridLayout>
            <AppGridLayout.SearchArea>
              <AppTableSearch onSearch={this.onSearch}>
                <AppTableSearch.Common>
                  <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
                </AppTableSearch.Common>
              </AppTableSearch>
            </AppGridLayout.SearchArea>
            <AppGridLayout.GridArea>
              <AppTable ref={this.refTable}
              >
                <AppTable.ColCheckbox />
                <AppTable.Col title='企业名称' field='openName' width={200} />
                <AppTable.Col title='企业标识' field='openId' />
              </AppTable>
            </AppGridLayout.GridArea>
          </AppGridLayout>
        </AppFormLayout.Form>
        <AppFormLayout.Footer>
          <AppRow>
            <AppButton label="引入" action={this.introduce} />
            <AppButton label="取消" action={AppAction.closeDialog} />
          </AppRow>
        </AppFormLayout.Footer>
      </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/pos/enterpriseRcb/EnterpriseRcbIntroduce.tsx